import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import useUsers from "../../hooks/utilisateur/useUsers";
import UsersServices from "../../services/utilisateur/UsersService";
import useEntreprises from "../../hooks/entreprise/useEntrepries";
import { FiUser, FiBriefcase, FiLock } from "react-icons/fi";
import "../../assets/css/createUser.css";

function CreateUser() {
  const { getAllEntreprises } = useEntreprises();
  const [entreprises, setEntreprises] = useState([]);
  const { getSuperviseurByEntrepriseId } = useUsers();
  const navigate = useNavigate();
  const { id } = useParams();
  const userData = JSON.parse(localStorage.getItem("user"));
  const [formData, setFormData] = useState({
    nom: "",
    prenom: "",
    email: "",
    photo: "/default.png",
    tel: "",
    adresse: "",
    role: "3",
    entreprise: "",
    gerant: [],
    department: "",
    password: "BPOSpyteam2025!",
    passwordConfirm: "BPOSpyteam2025!",
    adminId: userData._id,
    isDev: 2,
    isCapturePause: 1,
  });
  const [message, setMessage] = useState({ type: "", text: "" });
  const [error, setError] = useState("");
  const [entrepriseSelected, setEntrepriseSelected] = useState("");
  const [superviseursParEntreprise, setSuperviseursParEntreprise] = useState(
    [],
  );

  useEffect(() => {
    getAllEntreprises()
      .then((res) => {
        if (Array.isArray(res.data.data)) {
          setEntreprises(res.data.data);
        } else {
          console.error("La réponse de l'API n'est pas un tableau.");
        }
      })
      .catch((err) => console.error("Erreur API :", err));
  }, []);

  useEffect(() => {
    if (id) {
      UsersServices.getOne(id)
        .then((res) => {
          if (res.data) {
            setFormData(res.data.data);
            setEntrepriseSelected(res.data?.data?.entreprise?._id || "");
          }
        })
        .catch((err) => {
          console.error(
            "Erreur lors de la récupération de l'utilisateur :",
            err,
          );
          setMessage({
            type: "error",
            text: "Erreur lors du chargement des données.",
          });
        });
    } else {
      setFormData({
        ...formData,
        nom: "",
        prenom: "",
        email: "",
        photo: "/default.png",
        tel: "",
        adresse: "",
        role: "3",
        entreprise: "",
        gerant: [],
        department: "",
        isDev: 2,
        isCapturePause: 1,
      });
    }
  }, [id]);

  useEffect(() => {
    if (error) {
      setTimeout(() => {
        setError("");
      }, 3000);
    }
  }, [error]);

  useEffect(() => {
    if (entrepriseSelected) {
      getSuperviseurByEntrepriseId(entrepriseSelected, (data) => {
        if (data) {
          setSuperviseursParEntreprise(data);
        } else {
          setSuperviseursParEntreprise([]);
        }
      });
    } else {
      setSuperviseursParEntreprise([]);
    }
  }, [entrepriseSelected]);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (formData.role !== "1") {
      if (!formData.entreprise) {
        setError("Veuillez sélectionner une entreprise.");
        return;
      }
      if (formData.role === "3") {
        if (formData.gerant.length === 0) {
          setError("Veuillez sélectionner au moins un superviseur.");
          return;
        }
      }
    }

    if (id) {
      try {
        await UsersServices.update(id, formData);
        setMessage({
          type: "success",
          text: "Utilisateur mis à jour avec succès !",
        });
        setTimeout(() => navigate("/users"), 2000);
      } catch (err) {
        console.error("Erreur lors de la mise à jour :", err);
        setMessage({ type: "error", text: "Erreur lors de la mise à jour." });
      }
    } else {
      if (formData.password !== formData.passwordConfirm) {
        setError("Les mots de passe ne correspondent pas.");
        return;
      }
      setError("");
      try {
        await UsersServices.create(formData);
        setMessage({ type: "success", text: "Utilisateur créé avec succès !" });
        setTimeout(() => navigate("/users"), 2000);
      } catch (err) {
        console.error("Erreur création utilisateur :", err);

        if (err.response && err.response.data && err.response.data.message) {
          setError(err.response.data.message);
        } else {
          setError("Une erreur est survenue. Veuillez réessayer.");
        }
      }
    }
  };

  const handleEntrepriseChange = (e) => {
    const selectedId = e.target.value;
    setEntrepriseSelected(selectedId);
    setFormData((prev) => ({ ...prev, entreprise: selectedId, gerant: [] }));
  };

  const showPasswordFields =
    formData.role !== "3" && formData.role !== 3 && !formData._id;

  return (
    <div className="container-fluid">
      {/* TITLE */}
      <div className="d-flex align-items-center justify-content-between mb-4">
        <h2 className="h4 mb-0">
          {id ? "Modifier l'utilisateur" : "Créer un utilisateur"}
        </h2>
      </div>

      {message.text && (
        <div
          className={`alert ${
            message.type === "success" ? "alert-success" : "alert-danger"
          }`}
        >
          {message.text}
        </div>
      )}

      {error && <div className="alert alert-danger">{error}</div>}

      <div className="card shadow-sm">
        <div className="card-body">
          <form onSubmit={handleSubmit}>
            {/* ---- INFORMATIONS PERSONNELLES ---- */}
            <div className="form-section-label">
              <FiUser /> Informations personnelles
            </div>

            <div className="row g-3 mb-4">
              <div className="col-12 col-md-6">
                <label className="form-label">Nom</label>
                <input
                  type="text"
                  value={formData.nom || ""}
                  name="nom"
                  className="form-control"
                  onChange={handleChange}
                  required
                />
              </div>
              <div className="col-12 col-md-6">
                <label className="form-label">Prénom</label>
                <input
                  type="text"
                  value={formData.prenom || ""}
                  name="prenom"
                  className="form-control"
                  onChange={handleChange}
                  required
                />
              </div>

              <div className="col-12 col-md-6">
                <label className="form-label">Email</label>
                <input
                  type="email"
                  value={formData.email || ""}
                  name="email"
                  className="form-control"
                  onChange={handleChange}
                  required
                />
              </div>
              <div className="col-12 col-md-6">
                <label className="form-label">Téléphone</label>
                <input
                  type="tel"
                  value={formData.tel || ""}
                  name="tel"
                  className="form-control"
                  onChange={handleChange}
                  required
                />
              </div>

              <div className="col-12">
                <label className="form-label">Adresse</label>
                <input
                  type="text"
                  value={formData.adresse || ""}
                  name="adresse"
                  className="form-control"
                  onChange={handleChange}
                  required
                />
              </div>
            </div>

            {/* ---- RÔLE & AFFECTATION ---- */}
            <div className="form-section-label">
              <FiBriefcase /> Rôle & affectation
            </div>

            <div className="row g-3 mb-3">
              <div className="col-12 col-md-6">
                <label className="form-label">Rôle</label>
                <select
                  name="role"
                  value={formData.role}
                  className="form-select"
                  onChange={handleChange}
                  required
                >
                  <option value="">Sélectionner un rôle</option>
                  <option value="1">Admin</option>
                  <option value="2">Superviseur</option>
                  <option value="3">Collaborateur</option>
                </select>
              </div>

              <div className="col-12 col-md-6">
                <label className="form-label">Département</label>
                <input
                  type="text"
                  value={formData.department || ""}
                  name="department"
                  className="form-control"
                  onChange={handleChange}
                  required
                />
              </div>

              <div className="col-12 col-md-6">
                <label className="form-label">Entreprise</label>
                <select
                  className="form-select"
                  value={entrepriseSelected}
                  onChange={handleEntrepriseChange}
                  required
                >
                  <option value="">Sélectionner une entreprise</option>
                  {entreprises.map((ent) => (
                    <option key={ent._id} value={ent._id}>
                      {ent.nom}
                    </option>
                  ))}
                </select>
              </div>
            </div>

            {(formData.role === "3" || formData.role === 3) && (
              <div className="row g-3 mb-4">
                <div className="col-12 col-md-8">
                  <label className="form-label">Superviseurs</label>
                  <div
                    className={`supervisors-box ${
                      formData.entreprise ? "" : "supervisors-box--disabled"
                    }`}
                  >
                    {superviseursParEntreprise.length > 0 ? (
                      superviseursParEntreprise.map((sup) => (
                        <div key={sup._id} className="form-check">
                          <input
                            type="checkbox"
                            className="form-check-input"
                            id={`sup-${sup._id}`}
                            value={sup._id}
                            disabled={!formData.entreprise}
                            checked={formData?.gerant?.includes(sup._id)}
                            onChange={(e) => {
                              const isChecked = e.target.checked;
                              setFormData((prevData) => ({
                                ...prevData,
                                gerant: isChecked
                                  ? [...prevData?.gerant, sup._id]
                                  : prevData?.gerant?.filter(
                                      (_id) => _id !== sup._id,
                                    ),
                              }));
                            }}
                          />
                          <label
                            className="form-check-label"
                            htmlFor={`sup-${sup._id}`}
                          >
                            {sup.nom}
                          </label>
                        </div>
                      ))
                    ) : (
                      <p className="text-muted mb-0">
                        Aucun superviseur disponible
                      </p>
                    )}
                  </div>
                </div>
              </div>
            )}

            {/* ---- SÉCURITÉ ---- */}
            {showPasswordFields && (
              <>
                <div className="form-section-label">
                  <FiLock /> Sécurité
                </div>

                <div className="row g-3 mb-4">
                  <div className="col-12 col-md-6">
                    <label className="form-label">Mot de passe</label>
                    <input
                      type="password"
                      name="password"
                      className="form-control"
                      onChange={handleChange}
                      required={!id}
                    />
                  </div>
                  <div className="col-12 col-md-6">
                    <label className="form-label">
                      Confirmer le mot de passe
                    </label>
                    <input
                      type="password"
                      name="passwordConfirm"
                      className="form-control"
                      onChange={handleChange}
                      required={!id}
                    />
                  </div>
                </div>
              </>
            )}

            <div className="d-flex justify-content-end">
              <button type="submit" className="btn btn-success px-4">
                {id ? "Enregistrer" : "Créer"}
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
}

export default CreateUser;
